import axios from 'axios';
import { Capacitor } from '@capacitor/core';

// En el navegador (o la PWA instalada), la ruta relativa "/api" ya resuelve
// contra el mismo dominio que sirvió la app. Pero una app nativa de Capacitor
// carga sus archivos desde un origen local (https://localhost) que no tiene
// backend propio, así que ahí necesita la URL absoluta de producción.
const baseURL = Capacitor.isNativePlatform() ? 'https://gestionadrantaleh.com/api' : '/api';

const api = axios.create({
  baseURL,
  timeout: 15000,
});

// Agregar token a cada request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Manejar errores globalmente
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
